import { AppSettings } from 'src/settings/appsettings.interface';

export function validateAppSettings(settings: AppSettings | null | undefined): void {
  const missing: string[] = [];

  if (!settings?.appService?.baseUrl) {
    missing.push('appService.baseUrl');
  }
  if (!settings?.auth?.issuer) {
    missing.push('auth.issuer');
  }
  if (!settings?.auth?.clientId) {
    missing.push('auth.clientId');
  }
  if (!settings?.auth?.audience) {
    missing.push('auth.audience');
  }
  if (!settings?.auth?.logout?.url) {
    missing.push('auth.logout.url');
  }
  if (!settings?.auth?.logout?.redirectParameter) {
    missing.push('auth.logout.redirectParameter');
  }

  if (missing.length > 0) {
    throw new Error(`${missing.join(', ')} mangler`);
  }
}
